import { Accordion, AccordionDetails, Typography, strIsNullOrEmpty } from '@fox/atoms';
import { MembershipFormFieldTypes, SwiftFoxPersonDetails } from '../membership-form-template/contracts';
import { MembershipFormDateField, MembershipFormTextField } from '../membership-form-template/fields';
import { ProfileComponentProps } from './shared/contracts';
import { ResponsiveGrid } from './shared/profile-style-components';

export function PersonalDetails({
	values,
	errors,
	setFieldValue,
	touched,
	isEditing,
	profileFieldRules
}: ProfileComponentProps<SwiftFoxPersonDetails>) {
	const isEditable = fieldName => {
		const editRule = profileFieldRules.find(r => r.name === fieldName);
		if (!editRule) {
			return false;
		}
		return editRule.editable;
	};
	return (
		<Accordion
			title={
				<Typography variant="h5" component="h3">
					{isEditing ? 'Edit personal details' : 'Personal details'}
				</Typography>
			}
			defaultExpanded={false}
		>
			<AccordionDetails>
				<ResponsiveGrid>
					<MembershipFormTextField
						isEditing={isEditing && isEditable('title')}
						key="title"
						field={{
							name: 'title',
							label: 'Title',
							fieldType: MembershipFormFieldTypes.TextField
						}}
						helperText={touched['title'] ? errors['title'] : undefined}
						error={touched['title'] && !strIsNullOrEmpty(errors['title'])}
						setFieldValue={setFieldValue}
						value={values['title']}
					/>
					<MembershipFormTextField
						isEditing={false}
						key="firstName"
						field={{
							name: 'firstName',
							label: 'First name',
							fieldType: MembershipFormFieldTypes.TextField
						}}
						helperText={touched['firstName'] ? errors['firstName'] : undefined}
						error={touched['firstName'] && !strIsNullOrEmpty(errors['firstName'])}
						setFieldValue={setFieldValue}
						value={values['firstName']}
					/>
					<MembershipFormTextField
						isEditing={false}
						key="lastName"
						field={{
							name: 'lastName',
							label: 'Last name',
							fieldType: MembershipFormFieldTypes.TextField
						}}
						helperText={touched['lastName'] ? errors['lastName'] : undefined}
						error={touched['lastName'] && !strIsNullOrEmpty(errors['lastName'])}
						setFieldValue={setFieldValue}
						value={values['lastName']}
					/>
					<MembershipFormTextField
						isEditing={false}
						key="otherNames"
						field={{
							name: 'otherNames',
							label: 'Middle name',
							fieldType: MembershipFormFieldTypes.TextField
						}}
						helperText={touched['otherNames'] ? errors['otherNames'] : undefined}
						error={touched['otherNames'] && !strIsNullOrEmpty(errors['otherNames'])}
						setFieldValue={setFieldValue}
						value={values['otherNames']}
					/>
					<MembershipFormDateField
						isEditing={isEditing && isEditable('dob')}
						key="dob"
						field={{
							name: 'dob',
							label: 'Date of birth',
							fieldType: MembershipFormFieldTypes.DateField
						}}
						value={values['dob']}
						helperText={touched['dob'] ? (errors['dob'] as string) : undefined}
						error={touched['dob'] !== undefined && errors['dob'] !== undefined}
						setFieldValue={setFieldValue}
					/>
				</ResponsiveGrid>
			</AccordionDetails>
		</Accordion>
	);
}
